import { render } from "./ProductRequirementValues.vue?vue&type=template&id=64bc13d9"
import script from "./ProductRequirementValues.vue?vue&type=script&lang=js"
export * from "./ProductRequirementValues.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\projects\\external\\kazigraphix\\admin.kazigraphix\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__